import { ref } from 'vue'
import { defineStore } from 'pinia'
import type {
  CmsDeviceSettings,
  CmsDeviceSettingsRelation
} from '@nsftx/seven-client-retail-vue-sgp'

export const useLandingPageStore = defineStore('landingPage', () => {
  const landingPage = ref<CmsDeviceSettingsRelation | null>(null)

  const setLandingPage = (value: CmsDeviceSettingsRelation | null) => {
    landingPage.value = value
  }

  const syncFromDeviceSettings = (deviceSettings: CmsDeviceSettings) => {
    setLandingPage(deviceSettings.landingPage ?? null)
  }

  return {
    landingPage,
    setLandingPage,
    syncFromDeviceSettings
  }
})
